module.exports = __webpack_public_path__ + "static/img/4.68e8329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/4.png
// module id = cN40
// module chunks = 0